﻿var Handlebars = require('handlebars');
var i18n = require('l10n');
var Cards_Template = require('text-loader!../../js/templates/partial_templates/dashboard_cards.template.htm');
var Venue_Cards_Template = require('text-loader!../../js/templates/partial_templates/dashboard_venues_cards.template.htm');
var Queue_Cards_Template = require('text-loader!../../js/templates/partial_templates/dashboard_queues_cards.template.html');
var PreparationRowPartialTemplate = require('text-loader!../../js/templates/preparations/preparationRow.partial.template.html');
var LoginRowPartialTemplate = require('text-loader!../../js/templates/partial_templates/loginRow.partial.template.html');
var ProgressPartialTemplate = require('text-loader!../../js/templates/partial_templates/progress.partial.template.html');
var PoweredByPartialTemplate = require('text-loader!../../js/templates/partial_templates/poweredBy.partial.template.html');
var AdPartialTemplate = require('text-loader!../../js/templates/partial_templates/ad.partial.template.html');

Handlebars.registerPartial('cardsTemplate', Cards_Template);
Handlebars.registerPartial('venueCardsTemplate', Venue_Cards_Template);
Handlebars.registerPartial('queueCardsTemplate', Queue_Cards_Template);
Handlebars.registerPartial('preparationRowPartialTemplate', PreparationRowPartialTemplate);
Handlebars.registerPartial('loginRowPartial', LoginRowPartialTemplate);
Handlebars.registerPartial('progressPartial', ProgressPartialTemplate);
Handlebars.registerPartial('poweredByPartialTemplate', PoweredByPartialTemplate);
Handlebars.registerPartial('adPartialTemplate', AdPartialTemplate);


function replaceAccents(str) {
    var replacements = {
        'Ά' : 'Α',
        'Ί' : 'Ι',
        'Ύ' : 'Υ',
        'Ή' : 'Η',
        'Ό' : 'Ο',
        'Ώ' : 'Ω',
        'Έ' : 'Ε',
        'Ϊ' : 'Ι',
        'Ϋ' : 'Υ'
    };

    $.each(replacements, function(key, value) {
        str = str.replace(new RegExp(key, 'g'), value);
    });

    return str;
}


Handlebars.registerHelper('getIndexPlusOne', function(index, options) {
	return index + 1;
});

Handlebars.registerHelper('getAA', function(index, page, options) {
	page = page * 10;
	index ++;
	return page + index;
});


Handlebars.registerHelper('getIndexPlusTwo', function(index, options) {
	if( index == 0)
	{
	return  options.fn(this);
	}

	return options.inverse(this);
});

Handlebars.registerHelper('htmlInjections', function(index, options) {
	return new Handlebars.SafeString(""+index + 12);
});

Handlebars.registerHelper('getBadgeViaFlowStatus', function(flowStatus, options) {
	var flowStatusBadges = {
	    "Normal": "badge-success",
	    "Traffic": "badge-warning",
	    "Full": "badge-danger"
	};

	return new Handlebars.SafeString(flowStatusBadges[flowStatus]);
});

Handlebars.registerHelper('getFlowStatusTranslation', function(flowStatus, options) {
	var flowStatusBadges = {
	    "Normal": i18n.t("queue.flow_normal"),
	    "Traffic": i18n.t("queue.flow_traffic"),
	    "Full": i18n.t("queue.flow_full")
	};

	return new Handlebars.SafeString(flowStatusBadges[flowStatus]);
});

Handlebars.registerHelper('if_eq', function(a, b, options) {

    if(a == b) // Or === depending on your needs
        return options.fn(this);
    else
        return options.inverse(this);
});
Handlebars.registerHelper('if_neq', function(a, b, options) {

    if(a != b) // Or === depending on your needs
        return options.fn(this);
    else
        return options.inverse(this);
});

Handlebars.registerHelper('if_any', function(a, b, options) {
    if(a || b)
        return options.fn(this);

    return options.inverse(this);
});

Handlebars.registerHelper('if_not', function(a, options) {
    if(!a)
        return options.fn(this);
    else
        return options.inverse(this);
});

Handlebars.registerHelper('isSelected', function(a, b, options) {
    //console.info(a +" == "+ b);
    if(a == b) // Or === depending on your needs
        return "selected";
});

Handlebars.registerHelper('getLength', function(text,  options) {
    if(text)
        return text.length;
    else
        return 0;
});

Handlebars.registerHelper('getCharacterLeft', function(text, maxLength,  options) {
    if(text)
        return maxLength - text.length;
    else
        return maxLength;
});

Handlebars.registerHelper('ifAllowToUseIt', function(userLevel, maxLevel, options) {
    //console.info(userLevel +" > "+ maxLevel);
    if(userLevel <= maxLevel) // Or === depending on your needs
        return options.fn(this);
    else
        return options.inverse(this);
});

Handlebars.registerHelper('allowItToSpecificLevel', function(userLevel, allowLevelCommaSeparated, options) {
    var allowedLevels = allowLevelCommaSeparated.split(",");
    var canAllowThisLevel = false;
    for(var i = 0; i < allowedLevels.length; i++)
    {
        //console.info(allowedLevels[i]);
        if(userLevel == allowedLevels[i])
        {
            canAllowThisLevel = true;
            break;
        }
    }

    if(canAllowThisLevel)
        return options.fn(this);
    else
        return options.inverse(this);
});


Handlebars.registerHelper('ifIsNotNull', function(value, options) {
    //console.info("/"+value+"/");
    if(value) // Or === depending on your needs
        return options.fn(this);
    else
        return options.inverse(this);
});

Handlebars.registerHelper('defaultValueInCaseOfNull', function(value, text, options) {
    if(value) // Or === depending on your needs
        return value;
    else
        return text;
});

Handlebars.registerHelper('getAppropriateQueueStatus', function(queueStatus, openNow, options) {
    if(openNow) {

        if(queueStatus == 'Open' || queueStatus == 'Closed') // wrongly with status Closed
            return 'Open'
        else if(queueStatus == 'Suspended')
            return 'suspended';

        return 'Open';

    }else {
        return 'Closed';
    }
});

Handlebars.registerHelper('getRoleWithTranslation', function(privilegeLevel, options) {
    var key = "user.";

    switch(privilegeLevel)  {
        case "SupervisingAdmin":
            key += "supervising";
            break;
        case "OrganizationAdmin":
            key += "organization_admin";
            break;
        case "VenueAdmin":
            key += "venue_admin";
            break;
        case "VenueAgent":
            key += "venue_agent";
            break;
        default:
            key = "GOD";
            break;
    }

     return i18n.t(key);
});

Handlebars.registerHelper('defaultValueInCaseOfNullWithTranslation', function(key, value, defaultText, options) {
    if(value) // Or === depending on your needs
        return i18n.t(key + "." + value);
    else
        return i18n.t(key + "." + defaultText);
});

Handlebars.registerHelper('getPr', function(key, value, defaultText, options) {
    if(value) // Or === depending on your needs
        return i18n.t(key + "." + value);
    else
        return i18n.t(key + "." + defaultText);
});


Handlebars.registerHelper('getFullNameOr', function(name, lastname, username, options) {
    return new Handlebars.SafeString(
        (name != null && name != "")
        ? (lastname != null && lastname != "")
            ? lastname + " " + name
            : name
        : (lastname != null && lastname != "")
             ? lastname
             : username
    );
});

Handlebars.registerHelper('round', function(value, toFixed, options) {
    return value.toFixed(toFixed);
});

Handlebars.registerHelper('flowStatusColor', function(value, options) {
    if(value == 'Normal')
        return "color-green";
    else if(value == 'Traffic')
        return "color-orange";
    else
        return "color-red";
});
Handlebars.registerHelper('statusColor', function(value, options) {
    if(value == 'Open')
        return "color-green";
    else
        return "color-red";
});
Handlebars.registerHelper('perCent', function(value1, value2 ,options) {

    var total = value1 + value2;
    total = total == 0 ? 1 : total;
    var perCentValue  = value1/total * 100;
    return parseInt(perCentValue +"");
});

Handlebars.registerHelper('getPieData', function(served, pending, options) {
    var total = served + pending;
    total = total == 0 ? 1 : total;
    return (served/total *360) + "deg";
});

Handlebars.registerHelper('print', function(value1,options) {
    console.log(value1);
});

Handlebars.registerHelper('getMonitorGridId', function(index, collectionLength, options) {
    collectionLength+=""; //convert it to String, so it can be passed as an INDEX to the `gridLines` Object
    // to datas to pairnoume apo global_style_medias.css -> #monitor3.container
	var gridLines = {
	    "3": ["v", "t", "a"],
	    "4": ["c", "v", "t", "a"],
	    "5": ["c", "v", "t", "a", "p"]
	};
	return new Handlebars.SafeString(gridLines[collectionLength][index]);
});

//Sample usage: span {{t "my.key" }}
Handlebars.registerHelper('t', function (i18n_key, options) {
    var result;
    let count;
    if (options.hash.count) {
        count = parseInt(options.hash.count);
    } else if (options.hash.hasOwnProperty('count')) {
        count = 0;
    }
    if (options.hash) {
        options.hash.count = count;
        result = i18n.t(i18n_key, options.hash);
    } else {
        result = i18n.t(i18n_key);
    }

    return result;
});

//replaces accents from greek upper case characters
Handlebars.registerHelper('tu', function (i18n_key, options) {
    var result;
    let count;
    if (options.hash.count) {
        count = parseInt(options.hash.count);
    } else if (options.hash.hasOwnProperty('count')) {
        count = 0;
    }
    if (options.hash) {
        options.hash.count = count;
        result = i18n.t(i18n_key, options.hash);
    } else {
        result = i18n.t(i18n_key);
    }
    return replaceAccents(result.toUpperCase());
});

Handlebars.registerHelper('open_close_counter', function (counter_status, options) {
    var result;
    if (counter_status == "Open") {
        result = "badge-success";
    } else {
        result = "badge-danger";
    }

    return result;
});

Handlebars.registerHelper('display', function (imagePath, options) {
    var result;
    if (imagePath == null) {
        result = "block";
    } else{
        result = "none";
    }

    return result;
});
Handlebars.registerHelper('not_display', function (imagePath, options) {
    var result;
    if (imagePath != null) {
        result = "block";
    } else{
        result = "none";
    }

    return result;
});

Handlebars.registerHelper('isCounter', function (queueType, options) {
    var result;
    if (queueType == "COUNTER") {
        result = "block";
    } else {
        result = "none";
    }

    return result;
});

Handlebars.registerHelper('isExaminationChamber', function (queueType, options) {
    var result;
    if (queueType == "EXAMINATION_CHAMBER") {
        result = "block";
    } else {
        result = "none";
    }

    return result;
});

Handlebars.registerHelper('hasCustomAudio', function (queueAudioType, options) {
    var result;
    if (queueAudioType == "CUSTOM") {
        result = "block";
    } else {
        result = "none";
    }

    return result;
});

Handlebars.registerHelper('card_clear', function (index, options) {
    var result = index%3==0 ? "both" : "none";
    return result;
});

Handlebars.registerHelper('getFormattedRemainingMinutes', function (minutes, options) {
    return (minutes && (minutes+"").length == 1
        ? "0" + minutes + ":00"
        : minutes && (minutes+"").length == 2
            ? minutes + ":00"
            : minutes && (minutes+"").length > 2
                ? getHoursAndMinutesFor(minutes) + ":00"
                : "00:00"
    );
});

Handlebars.registerHelper('getTime', function (dateInMillis, options) {
    // format the date
    // add leading zeroes to single-digit hours/minutes
    let date = new Date(dateInMillis);
    let d = [
        '0' + date.getHours(),
        '0' + date.getMinutes()
    ].map(it => it.slice(-2)); // take last 2 digits of every component

    // join the components into date
    return d.join(':');
});

Handlebars.registerHelper('getDateTime', function (dateInMillis, options) {
    // format the date
    // add leading zeroes to single-digit day/month/hours/minutes
    let date = new Date(dateInMillis);
    let d = [
        '0' + (date.getMonth() + 1),
        '0' + date.getDate(),
        '0' + date.getHours(),
        '0' + date.getMinutes()
    ].map(it => it.slice(-2)); // take last 2 digits of every component

    // join the components into date
    return date.getFullYear() + '-' + d.slice(0, 2).join('-') + ' ' + d.slice(2).join(':');
});

Handlebars.registerHelper('getCurrentCounterName', function (countersArrays, currentTicket, options) {
    var counter = countersArrays.find(counter => counter.currentServicingTicketNumber == currentTicket);

    return counter != undefined ? counter.counter.name : "-";
});

Handlebars.registerHelper('getQueueNameForLang', function (queueData, options) {
    var lang = i18n.lng();
    if(lang == "en")
        return queueData.englishName;
    return queueData.name;
});

Handlebars.registerHelper('ticketStatusIcon', function (status, options) {

    var iconClass = "";
    var color = "";

    switch(status) {
        case "NotUsed":
            iconClass = "fas fa-times";
            color = "color: red;";
            break;

        case "Servicing":
            iconClass = "fas fa-bolt";
            color = "color: yellow;";
            break;

        case "Serviced":
            iconClass = "fas fa-check";
            color = "color: lime;";
            break;

        case "Pending":
            iconClass = "far fa-clock";
            color = "color: orange;";
            break;

        case "Cancelled":
            iconClass = "fas fa-times";
            color = "color: red;";
            break;

        case "Pre_Serviced":
            iconClass = "fas fa-info";
            color = "color: cyan;";
            break;

        default:
            iconClass = "fas fa-question";
            color = "color: white;";
            break;
    }

    return "<i class='" + iconClass + "' style='" + color + "'></i>";

});


Handlebars.registerHelper('ticketStatusText', function (status, options) {

    var text = "";
    var color = "";

    switch(status) {
        case "NotUsed":
            text = i18n.t("tickets.NotUsed");
            color = "color: red;";
            break;

        case "Servicing":
            text = i18n.t("tickets.Incoming");
            color = "color: yellow;";
            break;

        case "Serviced":
            text = i18n.t("tickets.Serviced");
            color = "color: lime;";
            break;

        case "Pending":
            text = i18n.t("tickets.Pending");
            color = "color: orange;";
            break;

        case "Cancelled":
            text = i18n.t("tickets.Cancelled");
            color = "color: red;";
            break;

        case "Pre_Serviced":
            text = i18n.t("tickets.Pre_Serviced");
            color = "color: cyan;";
            break;

        default:
            text = i18n.t("tickets.Unknown");
            color = "color: white;";
            break;
    }

    return "<span style='" + color + "'>" + text + "</span>";

});


Handlebars.registerHelper('getDisplayForQueue', function (queueData, options) {
    if(queueData.needsPreparation) {
        return "col-md-6";
    }

    return "col-md-8";
});

Handlebars.registerHelper('hideOnNonPreparation', function (queueData, options) {
    if(!queueData.needsPreparation)
        return options.inverse(this);

    return options.fn(this);
});

Handlebars.registerHelper('customerCodeLastDigits', function (cusCode, options) {
    if(!cusCode || cusCode.length <= 4)
        return cusCode;

    var indexFrom = cusCode.length - 4;

    return cusCode.toString().substring(indexFrom);
});

Handlebars.registerHelper('customerTicketCreationTime', function (date, options) {
    var timeFromDate = new Date(date).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false})

    return timeFromDate;
});

function nonEmptyString(str) {
    return str != null && str.trim().length > 0;
}

function getCustomerFullName(customer) {
    return nonEmptyString(customer.firstName) && nonEmptyString(customer.lastName)
        ? customer.firstName +" "+ customer.lastName
        : nonEmptyString(customer.firstName)
            ? customer.firstName
            : nonEmptyString(customer.lastName)
                ? customer.lastName
                : "("+ i18n.t('counter.noCustomerName') +")";
}

Handlebars.registerHelper('customerFullName', function (customer, options) {
    return getCustomerFullName(customer);
});

Handlebars.registerHelper('customerNameOrEmpty', function (firstName, lastName, options) {
    var customer = {
        "firstName": firstName,
        "lastName": lastName
    }

    return getCustomerFullName(customer);
});

Handlebars.registerHelper('priorityText', function (priorityNumber, options) {
    var priorityText = "";

    switch(priorityNumber) {
        case 1:
            priorityText = i18n.t('counter.priority.typical');
            break;
        case 2:
            priorityText = i18n.t('counter.priority.medium');
            break;
        case 3:
            priorityText = i18n.t('counter.priority.high');
            break;
        default:
            priorityText = i18n.t('priority.unknown');
            break;
    }

    return priorityText
});

Handlebars.registerHelper('getSelectedFieldsFromArrayAsSting', function (arr, fieldName) {
    var returnString = '';

    $.each(arr, function(index, val) {
        returnString += val[fieldName] + ', ';
    })
    return returnString.slice(0, -2);
});

function getHoursAndMinutesFor(minutes) {
    var hours = minutes/60;
    var remainingMinutes = minutes%60;

    return (hours && (hours+"").length == 1
        ? "0" + hours + ":00"
        : hours && (hours+"").length == 2
            ? hours + ":00"
            : hours + ((remainingMinutes+"").length == 1
                ? "0" + remainingMinutes + ":00" : remainingMinutes + ":00")
    );
}